import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark1Small: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCheckmark1Small"><Path fillRule="evenodd" clipRule="evenodd" d="M17.378 7.68207L11.1818 17.596L6.58578 13.0001L8 11.5859L10.8182 14.4041L15.682 6.62207L17.378 7.68207Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark1Small;
